<template>
  <Modal
    v-if="isVisible"
    :title="titulo"
    :visible="isVisible"
    :closable="true"
    :style="{ width: '480px' }"
    data-testid="cofre-modal"
    @update:visible="close"
  >
    <CofreForm
      :conta="contaData"
      :loading="isSubmitting"
      @submit="handleSubmit"
      @cancel="close"
    />
  </Modal>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFiltro } from '../../composables/useFiltro';
import { useCofre } from '../../composables/useCofre';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import CofreForm from './CofreForm.vue';

const { t } = useI18n();
const filtro = useFiltro();
const { criarConta, atualizarConta } = useCofre();

const isVisible = ref(false);
const isSubmitting = ref(false);
const contaData = ref<any>(null);

const titulo = computed(() => {
  return contaData.value?.id ? t('Editar Conta') : t('Nova Conta');
});

const open = (data?: { conta?: any }) => {
  contaData.value = data?.conta || null;
  isVisible.value = true;
};

const close = () => {
  isVisible.value = false;
  contaData.value = null;
};

const handleSubmit = async (formData: Record<string, any>) => {
  isSubmitting.value = true;
  try {
    const franquiaId = Number(filtro.currentFranchiseId.value || filtro.selectedFranchises.value[0]?.id);
    if (!franquiaId) throw new Error('Franquia não selecionada');

    if (contaData.value?.id) {
      await atualizarConta(contaData.value.id, formData);
    } else {
      await criarConta({ franquia_id: franquiaId, nome: formData.nome, banco: formData.banco, agencia: formData.agencia, conta: formData.conta, tipo: formData.tipo, saldo_atual: formData.saldo_atual, observacao: formData.observacao });
    }

    eventBus.emit('cofre.updated');
    close();
  } catch (e: any) {
    log('CofreModal', 'handleSubmit', 'Erro', e);
  } finally {
    isSubmitting.value = false;
  }
};

eventBus.on('modal.cofre.open', open);

onBeforeUnmount(() => {
  eventBus.off('modal.cofre.open', open);
});
</script>
